var $=jQuery;
jQuery(document).ready(function ($) {

  function openTab($section, targetId) {
    $section.find('.tab-btn').removeClass('active');
    $section.find('.tab-pane').removeClass('active');

    $section.find('.tab-btn[data-tab="' + targetId + '"]').addClass('active');
    $section.find('#' + targetId).addClass('active');

    $('html, body').animate({
      scrollTop: $section.offset().top - 80
    }, 500);
  }

  $('.product-custom-tabs').each(function () {
    var $section = $(this);

    // click tab button
    $section.find('.tab-btn').on('click', function () {
      var targetId = $(this).data('tab');
      openTab($section, targetId);
    });

    // click link ngoài tab
    $('a[href^="#"]').on('click', function (e) {
      var hash = $(this).attr('href').replace('#', '');
      var $targetBtn = $section.find('#' + hash);

      if ($targetBtn.length && $targetBtn.hasClass('tab-btn')) {
        e.preventDefault();

        var targetId = $targetBtn.data('tab');
        openTab($section, targetId);
      }
    });

  });

  $('footer .has-dropdown .footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
  function slider_mobile() {
    if($(window).width() <= 949){ 
      
    const $el = $(".st__full_slider.st__full_slider_2.collection-featured ul");

    if ($el.find("li").length > 2) {
        $el.flickity({
            prevNextButtons: true,
            groupCells: false,
            cellAlign: 'left',
            contain: true,
            pageDots: false
        });
        
    }
    $(".trust_icon_sec .page-width.icon-text-wrapper").flickity({
        prevNextButtons: false,
        groupCells: false,
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        autoPlay: 5000
    });
    }  
    
  }
  $(document).ready(slider_mobile);
  $(window).on('resize', function() {
    slider_mobile();
  });
    $('.acc-head').on('click', function() {
      if($(this).hasClass('active')) {
        $(this).siblings('.acc-content').slideUp();
        $(this).removeClass('active');
      }
      else {
        $('.acc-content').slideUp();
        $('.acc-head').removeClass('active');
        $(this).siblings('.acc-content').slideToggle();
        $(this).toggleClass('active');
      }
    });
    class PriceRange1 extends HTMLElement {
  connectedCallback() {
    this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
    this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
    this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
    this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");

    // Event listeners for text input focus and change
    this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
    this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());

    this.textInputLowerBound.addEventListener("change", (event) => {
      const newValue = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
      event.target.value = newValue;
      this.rangeLowerBound.value = newValue;
      this.updateRangeStyles();
    });

    this.textInputHigherBound.addEventListener("change", (event) => {
      const newValue = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
      event.target.value = newValue;
      this.rangeHigherBound.value = newValue;
      this.updateRangeStyles();
    });

    // Event listeners for range slider change and input
    this.rangeLowerBound.addEventListener("change", (event) => {
      this.textInputLowerBound.value = event.target.value;
      this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeHigherBound.addEventListener("change", (event) => {
      this.textInputHigherBound.value = event.target.value;
      this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeLowerBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
      this.textInputLowerBound.value = event.target.value;
      this.updateRangeStyles();
    });

    this.rangeHigherBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
      this.textInputHigherBound.value = event.target.value;
      this.updateRangeStyles();
    });
  }

  updateRangeStyles() {
    this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100}%`);
    this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100}%`);
  }
}

window.customElements.define("price-range1", PriceRange1);
});

function initQuickAddGallery(modal) {
  var $gallery = $(modal).find('.product-single__gallery');

  if (!$gallery.length || $gallery.hasClass('flickity-enabled')) return;

  var galleryItems = $gallery.find('.product-single__gallery-item').length;

  if (galleryItems > 1) {
    $gallery.flickity({
      imagesLoaded: true,
      groupCells: false,
      dragThreshold: 5,
      cellAlign: 'center',
      wrapAround: true,
      prevNextButtons: true,
      percentPosition: true,
      pageDots: true
    });
  }

  var $thumbnails = $(modal).find('.product-single__thumbnails li');

  $gallery.on('change.flickity', function (event, index) {
    $thumbnails.removeClass('active');
    $thumbnails.eq(index).addClass('active');
  });

  $thumbnails.first().addClass('active');

  $thumbnails.off('click').on('click', function () {
    var index = $(this).index();
    $gallery.flickity('select', index);
  });

  var $gallery1 = $(modal).find('.product-single__thumbnails');
  var galleryItems1 = $gallery1.find('.product-single__thumbnails-item').length;

  if (galleryItems1 > 3 && !$gallery1.hasClass('flickity-enabled')) {
    $gallery1.flickity({
      imagesLoaded: true,
      dragThreshold: 1,
      cellAlign: 'left',
      wrapAround: true,
      prevNextButtons: true,
      percentPosition: true,
      pageDots: false
    });
  }
}


// 🔥 OBSERVE modal open + content load
const observer = new MutationObserver(function () {
  const modal = document.querySelector('.quick-add-modal[open]');
  if (!modal) return;

  // wait until gallery actually exists
  const gallery = modal.querySelector('.product-single__gallery');

  if (gallery) {
    initQuickAddGallery(modal);
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});